import React from "react";
import { View, StyleSheet, TouchableOpacity, Platform, Dimensions } from "react-native";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import ImageCarousel from "../ImageCarousel/ImageCarousel";
import { COLORS, STRINGS } from "../../constants";

const FontAwesomeIcon =
  Platform.OS === "web"
    ? require("@fortawesome/react-fontawesome").FontAwesomeIcon
    : require("@fortawesome/react-native-fontawesome").FontAwesomeIcon;

const closeBtnSize = Platform.OS === "web" ? "2xl" : 32;
const { height } = Dimensions.get("window");

/**
 * ImageGalleryModal component displays a modal with an image carousel and a close button.
 *
 * @component
 * @param {object} props - Component props.
 * @param {object} props.navigation - React Navigation object for navigating between screens.
 * @param {object} props.route - Route object containing parameters passed to the screen.
 * @param {object} props.route.params - Parameters passed to the route.
 * @param {Array} props.route.params.data - Array of image data to display in the carousel.
 *
 * @example
 * <ImageGalleryModal navigation={navigation} route={{ params: { data: images } }} />
 */
const ImageGalleryModal = ({ navigation, route }) => {
  const { data } = route.params;
  const { accessibilityLabel } = route.params;

  return (
    <View style={styles.modalContainer}>
      <TouchableOpacity
        testID="close-button"
        accessibilityValue={{ text: STRINGS.closeImageButton }}
        accessibilityLabel={STRINGS.closeImageButton}
        onPress={() => navigation.goBack()}
        style={styles.closeButton}
      >
        <FontAwesomeIcon icon={faCircleXmark} size={closeBtnSize} color={COLORS.border} />
      </TouchableOpacity>

      <ImageCarousel data={data} height={height} accessibilityLabel={accessibilityLabel} />
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: COLORS.textLight,
  },
  closeButton: {
    alignSelf: "flex-end",
    padding: 16,
    paddingRight: 10,
  },
});

export default ImageGalleryModal;
